module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/no-cam-background-d9e469c9aef341156a5edee0542a224a.png";